export const visitasKeys = {
  all: ['visitas'] as const,
  lists: () => [...visitasKeys.all, 'list'] as const,
  list: (filters: Record<string, unknown>) => [...visitasKeys.lists(), filters] as const,
  // Stats cuelgan de lists() para que invalidar el listado también refresque los KPIs.
  stats: (filters: Record<string, unknown>) => [...visitasKeys.lists(), 'stats', filters] as const,
};
